import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EServicesRoutingModule } from './e-services-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { CoreModule } from '../../core/core.module';
import { EServicesCategoryComponent } from './e-services-category/e-services-category.component';
import { EServicesSubcategoryComponent } from './e-services-subcategory/e-services-subcategory.component';
import { AdministrativeProcedureDetailsComponent } from '../administrative-procedure-details/administrative-procedure-details.component';

@NgModule({
    declarations: [ EServicesCategoryComponent, EServicesSubcategoryComponent, AdministrativeProcedureDetailsComponent ],
    imports: [
        CommonModule,
        EServicesRoutingModule,
        SharedModule,
        CoreModule
    ]
})
export class EServicesModule { }